import styles from './CustomAlert.module.css';
import { Alert } from "react-bootstrap";
import { Alert as AlertInterface } from "../../providers/AlertProvider";
import parse from 'html-react-parser';
import { useNavigate } from "react-router-dom";

type Props = {
    alert: AlertInterface;
    onClose: (alert: AlertInterface) => void;
}

export default function CustomAlert({ 
    alert,
    onClose,
}: Props) {
    const navigate = useNavigate();

    return (
        <Alert className='mb-3'
            key={alert.id}
            variant={alert.type} 
            onClose={() => onClose(alert)}
            dismissible 
        >
            <div className={styles.alertContainer}>
                <div>{parse(alert.text)}</div>
                {alert.link && (
                    <div className='link' onClick={() => navigate(alert.link?.url ?? '')}>
                        {alert.link.text}
                    </div>
                )}
            </div>
        </Alert>
    );
}